import { Guid } from "../../DiscoveryEngine.TS/Utils/Guid";
import { StorageRootDto } from "../StorageRootDto";
import { UpdateResultDto } from "../UpdateResultDto";
import { Owner } from "./Owner";

export class ViewerDeviceGroupTreeNodeDto extends StorageRootDto {

	public UserGuid: string;
	public ScopeGuid: string;
	public Owner: Owner;
	public Image: string;
	public Name: string;
	public TagGuid: string;

	constructor(userGuid?: string, scopeGuid?: string, owner?: Owner,
				image?: string, name?: string, tagGuid?: string) {
		super();

		this.UserGuid = (userGuid ? userGuid : "");
		this.ScopeGuid = (scopeGuid ? scopeGuid : "");
		this.Owner = (owner ? owner : Owner.System);
		this.Image = (image ? image : "");
		this.Name = (name ? name : "");
		this.TagGuid = (tagGuid ? tagGuid : "");
	}

	public VerifyGuid(): string {
		if (!this.Guid) {
			this.Guid = Guid.Create().toString().toLowerCase();
		}
		return this.Guid;
	}

	public CopyProps(obj: UpdateResultDto, isCreate: boolean = true) {
		super.CopyProps(obj, isCreate);

		if (isCreate) {
			this.UserGuid = obj.UserGuid;
			this.ScopeGuid = obj.ScopeGuid;
		}
	}

	public Write(obj: any, context: any): void {

		// Called by subclass Write methods

		super.Write(obj, context);

		if (this.UserGuid)
			obj.user_guid = this.UserGuid;

		if (this.ScopeGuid)
			obj.scope_guid = this.ScopeGuid;

		obj.owner = Owner[this.Owner];

		if (this.Image)
			obj.image = this.Image;

		if (this.Name)
			obj.name = this.Name;

		if (this.TagGuid)
			obj.tag_guid = this.TagGuid;
	}

	public Read(obj: any, context: any): void {

		// Called by subclass Read methods

		super.Read(obj, context);

		if (obj.user_guid !== undefined)
			this.UserGuid = obj.user_guid;

		if (obj.scope_guid !== undefined)
			this.ScopeGuid = obj.scope_guid;

		if (obj.owner !== undefined)
			this.Owner = Owner[<string>obj.owner];

		if (obj.image !== undefined)
			this.Image = obj.image;

		if (obj.name)
			this.Name = obj.name;

		if (obj.tag_guid !== undefined)
			this.TagGuid = obj.tag_guid;
	}

}
